/**
 * React-query hook for `POST /v1/golab/snapshots/impact` (B12-BE).
 *
 * Modeled as a **mutation** (not a query) because each call carries two
 * `taxonomyData` blobs and fires from the taxonomy editor's save handler.
 * Read-only on the BE — no cache invalidation needed.
 *
 * Mirrors the conventions established in the sibling `useSnapshots.ts`:
 * no hook-level toasts (consumers handle UX), errors propagate as `Error`.
 */

import { useMutation } from '@tanstack/react-query';

import { snapshotService } from '../services/snapshotService';
import type { ImpactPayload, ImpactResult } from '../types';


export const useComputeImpact = () =>
  useMutation<ImpactResult, Error, ImpactPayload>({
    mutationFn: snapshotService.computeImpact,
  });
